import { Content, fetchOneEntry, getBuilderSearchParams, isPreviewing } from "@builder.io/sdk-react";
import type {
  LoaderFunction,
  MetaFunction,
} from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { fetch as webFetch } from "@remix-run/web-fetch";
import { CUSTOM_COMPONENTS } from "../builder-registry";
import CollectionGrid from "../components/CollectionGrid";
import prisma from "../../prisma/client";

export const meta: MetaFunction = () => {
  return [
    { title: "Veneration Businesses — Veneration Wear" },
    {
      name: "description",
      content: "Shop Veneration Businesses",
    },
  ];
};

type LoaderData = {
  brands: {
    title: string;
    imageUrl: string;
    buttonLink: string;
    description: string;  
  }[];
};

export const loader: LoaderFunction = async ({request}) => {
  // Imagine this data is fetched or passed as props
  const builderApiKey = process.env.PUBLIC_BUILDER_KEY!;
  const url = new URL(request.url);
  const urlPath = `/businesses`;

  const page = await fetchOneEntry({
    model: "page",
    apiKey: builderApiKey,
    options: getBuilderSearchParams(url.searchParams),
    userAttributes: { urlPath },
    fetch: webFetch,
  });

  const brands = (
    await prisma.user.findMany({
      where: {
        category: "Business",
      },
      select: {
        stores: {
          where: {
            active: true,
          },
          select: {
            name: true,
            handle: true,
            logo: true,
            description: true,
          },
        },
      },
    })
  ).filter((user) => user.stores.length > 0).map((user) => {
    return {
      title: user.stores[0].name,
      imageUrl: user.stores[0].logo,
      buttonLink: `/${user.stores[0].handle}`,
      description: user.stores[0].description,
    };
  });

  if (!page && !isPreviewing(url.search)) {
    throw new Response("Page Not Found", {
      status: 404,
      statusText: "Page not found in Builder.io",
    });
  }
  // Imagine this data is fetched or passed as props
  return {
    page,
    brands,
    builderApiKey,
  };
};

export default function Index() {
  const { brands } = useLoaderData<LoaderData>();
  const { page, builderApiKey } = useLoaderData<typeof loader>();

  return (
    <div className="pt-20">
      <CollectionGrid brands={brands} title="Meet the businesses" />
      <Content
        model="page"
        apiKey={builderApiKey}
        content={page}
        customComponents={CUSTOM_COMPONENTS}
      />
    </div>
  );
}
